module.exports = __webpack_public_path__ + "montreal-universities.png?7dfa21c8c77d2e7814dab373a150ba45";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/montreal-universities.png
// module id = 141
// module chunks = 0